import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Eye, Edit, Trash2 } from 'lucide-react';
import { Link as ReactRouterLink } from 'react-router-dom';

const GroupOfPeopleTable = ({
  data,
  loading,
  currentPage,
  onDelete,
}) => {
  const handleDeleteClick = (group) => {
    onDelete(group.id);
  };

  return (
    <TooltipProvider>
      <Table>
        <TableCaption>
          {`Página actual: ${currentPage || ''} | Registros: ${data?.length} `}
        </TableCaption>
        <TableHeader>
          <TableRow>
            <TableHead>Nombre</TableHead>
            <TableHead>Cantidad de Personas</TableHead>
            <TableHead>Acciones</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {!loading && data && data.map((group) => (
            <TableRow key={`person-${group.id}`}>
              <TableCell>{group.name}</TableCell>
              <TableCell>{group.people.length}</TableCell>
              <TableCell>
                <div className="flex gap-2">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        variant="outline"
                        size="sm"
                        asChild
                        className="rounded-full h-8 w-8 p-0"
                      >
                        <ReactRouterLink
                          to="/ver-grupo-personas"
                          state={{ group }}
                        >
                          <Eye className="h-4 w-4" />
                        </ReactRouterLink>
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Ver grupo</p>
                    </TooltipContent>
                  </Tooltip>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        variant="outline"
                        size="sm"
                        asChild
                        className="rounded-full h-8 w-8 p-0"
                      >
                        <ReactRouterLink
                          to="/editar-grupo-personas"
                          state={{ group }}
                        >
                          <Edit className="h-4 w-4" />
                        </ReactRouterLink>
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Editar grupo</p>
                    </TooltipContent>
                  </Tooltip>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleDeleteClick(group)}
                        className="rounded-full h-8 w-8 p-0"
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Eliminar grupo</p>
                    </TooltipContent>
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TooltipProvider>
  )
}

export default GroupOfPeopleTable;
